export const visualIdentityQueryKey = ["visual-identity"] as const;

export const fontOptions = [
  { value: "montserrat", label: "Montserrat · sólida y moderna" },
  { value: "inter", label: "Inter · clara y contemporánea" },
  { value: "libre-baskerville", label: "Libre Baskerville · institucional" },
  { value: "cormorant-garamond", label: "Cormorant Garamond · editorial" },
] as const;

export type FontChoice = (typeof fontOptions)[number]["value"];

export interface TypographySettings {
  heading: FontChoice;
  subtitle: FontChoice;
  body: FontChoice;
}

export const defaultTypographySettings: TypographySettings = {
  heading: "montserrat",
  subtitle: "inter",
  body: "inter",
};

export const fontStacks: Record<FontChoice, string> = {
  montserrat: '"Montserrat", Inter, "Segoe UI", Arial, sans-serif',
  inter: 'Inter, "Segoe UI", Arial, sans-serif',
  "libre-baskerville": '"Libre Baskerville", Georgia, serif',
  "cormorant-garamond": '"Cormorant Garamond", Georgia, serif',
};

export function normalizeFontChoice(
  value: unknown,
  fallback: FontChoice,
): FontChoice {
  return typeof value === "string" && value in fontStacks
    ? (value as FontChoice)
    : fallback;
}
